<template>
  <div
    @click="emitBuy" class="buy-credits__item "
    :class="{'buy-credits__item--starter': shopPackage.is_starter, 'buy-credits__item--premium': shopPackage.is_best_seller, 'buy-credits__item--sale': shopPackage.is_sale}"
  >
    <!--        <div class="card__name" v-if="shopPackage.is_starter">{{ trans.get('ms:shop.starter') }}</div>-->
    <!--        <div class="card__name" v-if="shopPackage.is_best_seller">{{ trans.get('ms:shop.best_seller') }}</div>-->
    <!--        <div class="card__name" v-if="!shopPackage.is_starter && !shopPackage.is_best_seller">{{ trans.get('ms:shop.basic_package') }}</div>-->
    <div class="card-wrapper">
      <div class="card__name">{{ shopPackage.name }}</div>
      <div class="card__sale" v-if="shopPackage.is_sale">{{ trans.get('ms:shop.sale') }} %</div>
      <div class="card__title-box">
        <div class="card__title-bonus" v-if="bonusAmount">+ {{ bonusAmount }} {{ trans.get('common.bonus') }}!
        </div>
        <div
          class="card__title-last-chance"
          v-if="shopPackage.unit === 'coin' && shopPackage.type === 'last-chance'"
        >{{
            trans.get('ms:shop.lc_package_special_offer')
          }}
        </div>
        <div class="card__title">
          {{ shopPackage.amount }}
          <i
            class="demo-icon icon-n-lova-coins"
            v-if="shopPackage.unit === 'coin' || ( shopPackage.unit === 'coin' && shopPackage.type === 'last-chance')"
          ></i>
        </div>
      </div>
      <div class="card__coins">
                <span class="coins-amount">{{ shopPackage.amount }} <img
                  src="../../../images/others/coin.svg"
                  class="coin-icon"
                ></span>
      </div>
      <div class="card__info">
        <div class="info__line" v-for="tag in shopPackage.tags">
          <span class="">{{ tag }}</span>
        </div>
      </div>

      <div class="card__button">
        <button class="button" name="customer_shop_package">
                <span class="d-none d-md-inline" v-if="shopPackage.type === 'last-chance'">
                    {{ trans.get('common.only') }}
                </span>
          {{ price }} &euro;
          <i class="demo-icon icon-shopping-basket"></i>
        </button>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'PackageElement',
  components: {},
  props: {
    shopPackage: Object,
    fee: Number,
    voucher: Object,
  },
  data() {
    return {};
  },
  computed: {
    price: function () {
      const price = (Math.round(this.shopPackage.price * (1 + (this.fee / 100))) / 100).toFixed(2);
      this.$emit('price', price);
      return price;
    },
    jokerIcon: function () {
      return this.shopPackage.unit === 'joker' && this.shopPackage.type !== 'last-chance';
    },
    bonusAmount: function () {
      if (this.voucher && this.voucher.type === window.globals.voucher.type_percent) {
        return Math.ceil(this.shopPackage.amount * (this.voucher.discount / 100));
      }

      if (this.voucher && this.voucher.type === window.globals.voucher.type_quantity) {
        return this.voucher.discount;
      }

      return null;
    },
    discountedAmount: function () {
      return this.shopPackage.amount + this.bonusAmount;
    }
  },
  watch: {
    price: function (newVal) {
      this.$emit('price', newVal);
    },
  },
  methods: {
    emitBuy: function () {
      this.$emit('buy', { package_id: this.shopPackage.id, price: this.price });
    },
  },
  mounted() {
  }
};
</script>
